import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectService } from '../../../services/project.service';

@Component({
  selector: 'app-home-projects-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './home-projects-section.component.html',
})
export class HomeProjectsSectionComponent {
  constructor(public projectService: ProjectService) {
    this.projectService.setHomeData();
  }
}
